import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__classifieds_quick_search',
    path: '/quick-search/:root?/:category?/:subCategory?',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/quick-search.vue' /* webpackChunkName: "pages-classifieds-quick-search" */
        )
      ),
    meta: {
      showOneTap: true,
      noFooter: 'mobile',
      hideMobileBottomMenu: true
    }
  }
]
